import { render, staticRenderFns } from "./MatchRules.vue?vue&type=template&id=e68bbd0e&"
import script from "./MatchRules.vue?vue&type=script&lang=ts&"
export * from "./MatchRules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports